/// <reference types="vite/client" />
/**
 * API routing abstraction layer.
 *
 * Currently always returns the cloud base URL.
 * Extension point: when local AI sidecar support is added, agent/LLM
 * endpoints can be routed to localhost while auth/billing stay on cloud.
 */

type ApiTarget = 'cloud'; // Future: | 'local'

const CLOUD_API_BASE_URL: string = (() => {
  // The native broker owns server selection. API consumers use local /api
  // paths that the desktop fetch bridge dispatches to the configured server.
  if (typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window) return '';
  const envVal = (
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_PLUGIN_API_BASE_URL ||
    import.meta.env.VITE_AGENT_API_BASE_URL ||
    ''
  ).trim().replace(/\/+$/, '');

  if (envVal) return envVal;

  const appBase = (import.meta.env.BASE_URL || '').trim().replace(/\/+$/, '');
  if (appBase) return appBase === '/' ? '' : appBase;

  // 이 저장소는 Samsung on-prem 전용이다. 명시적 환경값이 없으면 현재
  // origin의 상대 API만 사용하며 hosted askyour.ai로 폴백하지 않는다.
  return '';
})();

export function resolveBaseUrl(
  _endpoint: string,
  _target: ApiTarget = 'cloud',
): string {
  // Phase 1: always cloud
  return CLOUD_API_BASE_URL;

  // Future local routing:
  // const LOCAL_ENDPOINTS = ['/api/v1/agent/', '/api/v1/workspaces/', '/api/v1/llm/'];
  // if (_target === 'local' && LOCAL_ENDPOINTS.some(p => _endpoint.startsWith(p))) {
  //   return 'http://localhost:9205';
  // }
  // return CLOUD_API_BASE_URL;
}

export function getCloudApiBaseUrl(): string {
  return CLOUD_API_BASE_URL;
}
